export default "__VITE_ASSET__ChsoYzN3__"